import React from 'react'
import IngredientsInput from '../../IngredientInput'
import AllergicIngredientsInput from '../../AllergicIngredients'
import { SectionCard } from './SectionCard'
import styles from './styles.module.css'

export const IngredientsSection = ({
  ingredients, setIngredients,
  allergicIngredients, setAllergicIngredients
}) => (
  <SectionCard title='Ingredients'>
    <div className={styles.ingredientsRow}>
      <div className={styles.ingredientCol}>
        <IngredientsInput ingredients={ingredients} setIngredients={setIngredients} />
      </div>
      <div className={styles.ingredientCol}>
        <AllergicIngredientsInput
          allergicIngredients={allergicIngredients}
          setAllergicIngredients={setAllergicIngredients}
        />
      </div>
    </div>
  </SectionCard>
)
